// import React, { useState } from "react";
// import "../assets/UpdatePassword.css";
// import { useDispatch } from "react-redux";
// import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";
// import axios from "axios";
// import { toast } from "react-toastify";
// import { MdLock, MdKey } from "react-icons/md";

// const UpdatePassword = () => {
//   const dispatch = useDispatch();

//   const [filterType, setFilterType] = useState("Employee id");
//   const [filterValue, setFilterValue] = useState("");
//   const [selectedEmployee, setSelectedEmployee] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const [formData, setFormData] = useState({
//     oldPassword: "",
//     newPassword: "",
//     confirmPassword: "",
//     oldPin: "",
//     newPin: "",
//     confirmPin: ""
//   });

//   const superAdminId = localStorage.getItem("adminuserId") || "12";

//   // 🔍 Search Employee
//   const handleSearch = async () => {
//     if (!filterValue?.trim()) {
//       return toast.warn("Please enter a value to search.");
//     }

//     let query = { superAdminId };

//     switch (filterType) {
//       case "Employee id":
//         query.userId = filterValue.trim();
//         break;
//       case "pan":
//         query.panNumber = filterValue.trim();
//         break;
//       case "aadhaar":
//         query.aadhaarNumber = filterValue.trim();
//         break;
//       case "mobile":
//         query.mobileNumber = filterValue.trim();
//         break;
//       default:
//         return toast.warn("Unsupported filter type.");
//     }

//     try {
//       setLoading(true);
//       const response = await axios.get("https://payyug.in/api/get-employ-filter", {
//         params: query,
//       });

//       if (response.data?.status === false || !response.data?.data) {
//         setSelectedEmployee(null);
//         return toast.info(response.data?.message || "Employee not found.");
//       }

//       const emp = response.data.data;

//       setSelectedEmployee({
//         id:emp.id,
//         userId: emp.userId,
//         name: emp.fullName,
//         pan: emp.panNumber,
//         aadhaar: emp.aadhaarNumber,
//         mobile: emp.mobileNumber,
//         dob: emp.dateOfBirth?.slice(0, 10),
//       });

//       // fetch employee details
//       dispatch(fetchEmployeeReport({ page: 1, userId: emp.userId }));
//     } catch (err) {
//       console.error(err);
//       setSelectedEmployee(null);
//       toast.error("Failed to fetch employee. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // 📝 Input Change
//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   // 📌 Update Password
//   const handleUpdatePassword = async () => {
//     if (!selectedEmployee) return toast.error("Please search and select an employee first!");

//     const { oldPassword, newPassword, confirmPassword } = formData;
//     if (!oldPassword || !newPassword || !confirmPassword) {
//       return toast.error("Please fill all password fields.");
//     }
//     if (newPassword !== confirmPassword) {
//       return toast.error("New Password and Confirm Password do not match!");
//     }

//     try {
//       await axios.post(
//         `https://payyug.in/api/update-password-employee/${selectedEmployee.id}`,
//         { oldPassword, newPassword, confirmPassword }
//       );
//       toast.success("Password updated successfully!");
//       setFormData({ ...formData, oldPassword: "", newPassword: "", confirmPassword: "" });
//     } catch (err) {
//       console.error(err);
//       toast.error(err.response?.data?.message || "Failed to update password.");
//     }
//   };

//   // 📌 Update PIN
//   const handleUpdatePin = async () => {
//     if (!selectedEmployee) return toast.error("Please search and select an employee first!");

//     const { oldPin, newPin, confirmPin } = formData;
//     if (!oldPin || !newPin || !confirmPin) {
//       return toast.error("Please fill all PIN fields.");
//     }
//     if (newPin !== confirmPin) {
//       return toast.error("New PIN and Confirm PIN do not match!");
//     }

//     try {
//       await axios.post(
//         `https://payyug.in/api/update-pin-employee/${selectedEmployee.id}`,
//         { oldPin, newPin, confirmPin }
//       );
//       toast.success("PIN updated successfully!");
//       setFormData({ ...formData, oldPin: "", newPin: "", confirmPin: "" });
//     } catch (err) {
//       console.error(err);
//       toast.error(err.response?.data?.message || "Failed to update PIN.");
//     }
//   };

//   return (
//     <div className="UpdatePassword-container">
//       <div className="UpdatePassword-form">
//         <h2 className="UpdatePassword-title">
//           <MdLock /> Reset Employee Password & PIN
//         </h2>

//         {/* Search Employee */}
//         <section>
//           <h2>Search Employee</h2>
//           <div className="search-controls">
//             <select
//               value={filterType}
//               onChange={(e) => {
//                 setFilterType(e.target.value);
//                 setFilterValue("");
//               }}
//             >
//               <option value="">Select Filter</option>
//               <option value="Employee id">Employee ID</option>
//               <option value="pan">PAN</option>
//               <option value="aadhaar">Aadhaar</option>
//               <option value="mobile">Mobile</option>
//             </select>
//             <input
//               type="text"
//               placeholder={`Enter ${filterType || "value"}`}
//               value={filterValue}
//               onChange={(e) => setFilterValue(e.target.value)}
//             />
//             <button onClick={handleSearch} disabled={loading}>
//               {loading ? "Searching..." : "Search"}
//             </button>
//           </div>
//         </section>

//         {/* Employee Details */}
//         {selectedEmployee && (
//           <div className="kyc-table-employe">
//             <section>
//               <h2>Employee Details</h2>
//               <table>
//                 <tbody>
//                   <tr><th>User ID</th><td>{selectedEmployee?.userId}</td></tr>
//                   <tr><th>Name</th><td>{selectedEmployee?.name}</td></tr>
//                   <tr><th>PAN</th><td>{selectedEmployee?.pan}</td></tr>
//                   <tr><th>Aadhaar</th><td>{selectedEmployee?.aadhaar}</td></tr>
//                   <tr><th>Mobile</th><td>{selectedEmployee?.mobile}</td></tr>
//                   <tr><th>DOB</th><td>{selectedEmployee?.dob}</td></tr>
//                 </tbody>
//               </table>
//             </section>
//           </div>
//         )}

//         {/* Update Form */}
//         <div className="UpdatePassword-columns">
//           {/* Password Section */}
//           <div className="UpdatePassword-section">
//             <h4 className="UpdatePassword-subheading">
//               <MdLock /> Password
//             </h4>
//             <div className="UpdatePassword-field">
//               <label>Old Password</label>
//               <input
//                 type="password"
//                 name="oldPassword"
//                 value={formData.oldPassword}
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="UpdatePassword-field">
//               <label>New Password</label>
//               <input
//                 type="password"
//                 name="newPassword"
//                 value={formData.newPassword}
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="UpdatePassword-field">
//               <label>Confirm Password</label>
//               <input
//                 type="password"
//                 name="confirmPassword"
//                 value={formData.confirmPassword}
//                 onChange={handleChange}
//               />
//             </div>
//             <button
//               type="button"
//               className="UpdatePassword-button"
//               onClick={handleUpdatePassword}
//             >
//               <MdLock /> Update Password
//             </button>
//           </div>

//           {/* PIN Section */}
//           <div className="UpdatePassword-section">
//             <h4 className="UpdatePassword-subheading">
//               <MdKey /> PIN
//             </h4>
//             <div className="UpdatePassword-field">
//               <label>Old PIN</label>
//               <input
//                 type="password"
//                 name="oldPin"
//                 maxLength="6"
//                 value={formData.oldPin}
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="UpdatePassword-field">
//               <label>New PIN</label>
//               <input
//                 type="password"
//                 name="newPin"
//                 maxLength="6"
//                 value={formData.newPin}
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="UpdatePassword-field">
//               <label>Confirm PIN</label>
//               <input
//                 type="password"
//                 name="confirmPin"
//                 maxLength="6"
//                 value={formData.confirmPin}
//                 onChange={handleChange}
//               />
//             </div>
//             <button
//               type="button"
//               className="UpdatePassword-button"
//               onClick={handleUpdatePin}
//             >
//               <MdKey /> Update PIN
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UpdatePassword;




import React, { useEffect, useState } from "react";
import "../assets/UpdatePassword.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";
import axios from "axios";
import Select from "react-select";
import { toast } from "react-toastify";
import { 
  MdLock, 
  MdKey, 
  MdVisibility, 
  MdVisibilityOff, 
  MdPerson, 
} from "react-icons/md";

const UpdatePassword = () => {
  const dispatch = useDispatch();
  const { list: employeeReport } = useSelector((state) => state.employeeReport);

  const employeesList = employeeReport?.data || employeeReport || [];

  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [loading, setLoading] = useState(false);

  // Form States
  const [formData, setFormData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
    oldPin: "",
    newPin: "",
    confirmPin: "",
  });

  // Password / PIN Visibility Toggles
  const [showOldPass, setShowOldPass] = useState(false);
  const [showNewPass, setShowNewPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);

  const [showOldPin, setShowOldPin] = useState(false);
  const [showNewPin, setShowNewPin] = useState(false);
  const [showConfirmPin, setShowConfirmPin] = useState(false);

  const superAdminId = localStorage.getItem("adminuserId") || "12";

  useEffect(() => {
    dispatch(fetchEmployeeReport({ page: 1, limit: 100000, superAdminId }));
  }, [dispatch, superAdminId]);

  // Employee Selection Handler
  const handleEmployeeSelect = (selectedOption) => {
    if (!selectedOption) {
      setSelectedEmployee(null);
      return;
    }

    const emp = selectedOption.employeeData;
    setSelectedEmployee({
      id: emp.id,
      userId: emp.userId,
      name: emp.fullName || emp.name,
      pan: emp.panNumber || "N/A",
      aadhaar: emp.aadhaarNumber || "N/A",
      mobile: emp.mobileNumber || "N/A",
      dob: emp.dateOfBirth
        ? new Date(emp.dateOfBirth).toLocaleDateString("en-GB")
        : "N/A",
    });
  };

  // Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Password Update Handler
  const handleUpdatePassword = async () => {
    if (!selectedEmployee) return toast.error("Please search and select an employee first!");

    const { oldPassword, newPassword, confirmPassword } = formData;
    if (!oldPassword || !newPassword || !confirmPassword) {
      return toast.error("Please fill all password fields.");
    }
    if (newPassword.length < 6) {
      return toast.error("New password must be at least 6 characters long.");
    }
    if (newPassword !== confirmPassword) {
      return toast.error("New Password and Confirm Password do not match!");
    }

    try {
      setLoading(true);
      await axios.post(
        `https://payyug.in/api/update-password-employee/${selectedEmployee.id}`,
        { oldPassword, newPassword, confirmPassword }
      );
      toast.success("Password updated successfully!");
      setFormData((prev) => ({
        ...prev,
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      }));
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to update password.");
    } finally {
      setLoading(false);
    }
  };

  // 📌 PIN Update Handler
  const handleUpdatePin = async () => {
    if (!selectedEmployee) return toast.error("Please search and select an employee first!");

    const { oldPin, newPin, confirmPin } = formData;
    if (!oldPin || !newPin || !confirmPin) {
      return toast.error("Please fill all PIN fields.");
    }
    if (newPin.length !== 4 && newPin.length !== 6) {
      return toast.error("PIN must be either 4 or 6 digits long.");
    }
    if (newPin !== confirmPin) {
      return toast.error("New PIN and Confirm PIN do not match!");
    }

    try {
      setLoading(true);
      await axios.post(
        `https://payyug.in/api/update-pin-employee/${selectedEmployee.id}`,
        { oldPin, newPin, confirmPin }
      );
      toast.success("PIN updated successfully!");
      setFormData((prev) => ({
        ...prev,
        oldPin: "",
        newPin: "",
        confirmPin: "",
      }));
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to update PIN.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="UpdatePassword-container">
      <div className="UpdatePassword-form">
        <h2 className="UpdatePassword-title">
          <MdLock /> Reset Employee Password &amp; PIN
        </h2>

        {/* Search Employee Dropdown */}
        <div className="search-controls-employee">
          <Select
            className="employee-search-select"
            classNamePrefix="react-select"
            placeholder="Search Employee by Name or ID..."
            isClearable
            isSearchable
            isLoading={loading}
            options={employeesList.map((emp) => ({
              value: emp.userId || emp.id,
              label: `${emp.fullName || emp.name || "N/A"} (${emp.userId})`,
              employeeData: emp,
            }))}
            value={
              selectedEmployee
                ? {
                    value: selectedEmployee.userId,
                    label: `${selectedEmployee.name} (${selectedEmployee.userId})`,
                  }
                : null
            }
            onChange={handleEmployeeSelect}
          />
        </div>

        {/* Selected Employee Info Card */}
        {selectedEmployee && (
          <div className="UpdatePassword-userCard">
            <h3><MdPerson /> Employee Details</h3>
            <div className="UpdatePassword-grid">
              <div className="UpdatePassword-infoBox">
                <strong>User ID:</strong> {selectedEmployee.userId}
              </div>
              <div className="UpdatePassword-infoBox">
                <strong>Name:</strong> {selectedEmployee.name}
              </div>
              <div className="UpdatePassword-infoBox">
                <strong>PAN:</strong> {selectedEmployee.pan}
              </div>
              <div className="UpdatePassword-infoBox">
                <strong>Aadhaar:</strong> [Aadhaar Redacted]
              </div>
              <div className="UpdatePassword-infoBox">
                <strong>Mobile:</strong> {selectedEmployee.mobile}
              </div>
              <div className="UpdatePassword-infoBox">
                <strong>DOB:</strong> {selectedEmployee.dob}
              </div>
            </div>
          </div>
        )}

        {/* Input Sections (Password & PIN) */}
        <div className="UpdatePassword-columns">
          {/* Password Section */}
          <div className="UpdatePassword-section">
            <h4 className="UpdatePassword-subheading">
              <MdLock /> Update Password
            </h4>

            <div className="UpdatePassword-field">
              <label>Old Password</label>
              <div className="input-wrapper">
                <input
                  type={showOldPass ? "text" : "password"}
                  name="oldPassword"
                  placeholder="Enter old password"
                  value={formData.oldPassword}
                  onChange={handleChange}
                />
                <span className="toggle-icon" onClick={() => setShowOldPass(!showOldPass)}>
                  {showOldPass ? <MdVisibilityOff /> : <MdVisibility />}
                </span>
              </div>
            </div>

            <div className="UpdatePassword-field">
              <label>New Password</label>
              <div className="input-wrapper">
                <input
                  type={showNewPass ? "text" : "password"}
                  name="newPassword"
                  placeholder="Enter new password"
                  value={formData.newPassword}
                  onChange={handleChange}
                />
                <span className="toggle-icon" onClick={() => setShowNewPass(!showNewPass)}>
                  {showNewPass ? <MdVisibilityOff /> : <MdVisibility />}
                </span>
              </div>
            </div>

            <div className="UpdatePassword-field">
              <label>Confirm Password</label>
              <div className="input-wrapper">
                <input
                  type={showConfirmPass ? "text" : "password"}
                  name="confirmPassword"
                  placeholder="Confirm new password"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                />
                <span className="toggle-icon" onClick={() => setShowConfirmPass(!showConfirmPass)}>
                  {showConfirmPass ? <MdVisibilityOff /> : <MdVisibility />}
                </span>
              </div>
            </div>

            <button
              type="button"
              className="UpdatePassword-button"
              disabled={loading}
              onClick={handleUpdatePassword}
            >
              <MdLock /> Update Password
            </button>
          </div>

          {/* PIN Section */}
          <div className="UpdatePassword-section">
            <h4 className="UpdatePassword-subheading">
              <MdKey /> Update PIN
            </h4>

            <div className="UpdatePassword-field">
              <label>Old PIN</label>
              <div className="input-wrapper">
                <input
                  type={showOldPin ? "text" : "password"}
                  name="oldPin"
                  maxLength="6"
                  placeholder="Enter old PIN"
                  value={formData.oldPin}
                  onChange={handleChange}
                />
                <span className="toggle-icon" onClick={() => setShowOldPin(!showOldPin)}>
                  {showOldPin ? <MdVisibilityOff /> : <MdVisibility />}
                </span>
              </div>
            </div>

            <div className="UpdatePassword-field">
              <label>New PIN</label>
              <div className="input-wrapper">
                <input
                  type={showNewPin ? "text" : "password"}
                  name="newPin"
                  maxLength="6"
                  placeholder="Enter new PIN"
                  value={formData.newPin}
                  onChange={handleChange}
                />
                <span className="toggle-icon" onClick={() => setShowNewPin(!showNewPin)}>
                  {showNewPin ? <MdVisibilityOff /> : <MdVisibility />}
                </span>
              </div>
            </div>

            <div className="UpdatePassword-field">
              <label>Confirm PIN</label>
              <div className="input-wrapper">
                <input
                  type={showConfirmPin ? "text" : "password"}
                  name="confirmPin"
                  maxLength="6"
                  placeholder="Confirm new PIN"
                  value={formData.confirmPin}
                  onChange={handleChange}
                />
                <span className="toggle-icon" onClick={() => setShowConfirmPin(!showConfirmPin)}>
                  {showConfirmPin ? <MdVisibilityOff /> : <MdVisibility />}
                </span>
              </div>
            </div>

            <button
              type="button"
              className="UpdatePassword-button"
              disabled={loading}
              onClick={handleUpdatePin}
            >
              <MdKey /> Update PIN
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdatePassword;